// extracted by mini-css-extract-plugin
export var customGif = "styles-module--custom-gif--8a2cd";
export var customOrderedList = "styles-module--custom-ordered-list--98083";
export var customParagraph = "styles-module--custom-paragraph--3118f";
export var customUnorderedList = "styles-module--custom-unordered-list--915c9";